export interface ActionBarButton {
  id: string;
  labelKey: string;
  onClick(): void;
  disabled?: boolean;
}

export interface ActionBarHandle {
  setButtons(buttons: readonly ActionBarButton[]): void;
  destroy(): void;
}

export function createActionBar(
  root: HTMLElement,
  initial: readonly ActionBarButton[],
): ActionBarHandle {
  function render(buttons: readonly ActionBarButton[]): void {
    root.replaceChildren();
    for (const b of buttons) {
      const btn = document.createElement('button');
      btn.className = 'pb-actionbar-btn';
      btn.textContent = b.labelKey;
      btn.dataset.actionId = b.id;
      if (b.disabled) btn.disabled = true;
      btn.addEventListener('click', () => b.onClick());
      root.appendChild(btn);
    }
  }

  render(initial);
  return {
    setButtons(next) {
      render(next);
    },
    destroy() {
      root.replaceChildren();
    },
  };
}
